import { Helmet } from "react-helmet";

const FAQSchema = ({ faqs }) => {

const schema = {

"@context":"https://schema.org",

"@type":"FAQPage",

"mainEntity":faqs.map(faq=>({

"@type":"Question",

"name":faq.question,

"acceptedAnswer":{

"@type":"Answer",

"text":faq.answer

}

}))

};

return(

<Helmet>

<script type="application/ld+json">

{JSON.stringify(schema)}

</script>

</Helmet>

);

};

export default FAQSchema;